import EmblaCarousel from 'embla-carousel';
import AutoHeight from 'embla-carousel-auto-height';
import AutoPlay from 'embla-carousel-autoplay';

export const ReviewsCarousel = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const emblaNode = document.querySelector('.reviews-carousel__embla');
        const slides = document.querySelectorAll('.reviews-carousel__container article');
        const prevButton = document.querySelector('.reviews-carousel__buttons--prev');
        const nextButton = document.querySelector('.reviews-carousel__buttons--next');

        if (!emblaNode) {
            console.warn('Element .reviews-carousel__embla not found.');
            return;
        }

        if (slides.length === 1) {
            emblaNode.classList.add('is-single');
            return;
        }

        const options = { loop: false };
        const emblaApi = EmblaCarousel(emblaNode, options, [
            AutoPlay({ delay: 30000, stopOnMouseEnter: true, stopOnInteraction: false }),
        ]);

        let isDragging = false;

        emblaApi.on('pointerDown', () => {
            emblaNode.classList.add('is-grabbing');
            isDragging = false;
        });

        emblaApi.on('pointerUp', () => {
            emblaNode.classList.remove('is-grabbing');
        });

        emblaApi.on('scroll', () => {
            isDragging = true;
        });

        slides.forEach((slide) => {
            const showMoreButton = slide.querySelector('.reviews-carousel__button');
            const reviewText = slide.querySelector('.reviews-carousel__text');

            if (showMoreButton && reviewText) {
                const lineHeight = parseInt(window.getComputedStyle(reviewText).lineHeight, 10);
                const textHeight = reviewText.scrollHeight;
                const numberOfLines = Math.round(textHeight / lineHeight);

                if (numberOfLines <= 5) {
                    showMoreButton.style.display = 'none';
                } else {
                    showMoreButton.addEventListener('click', () => {
                        const isExpanded = reviewText.getAttribute('data-expanded') === 'true';
                        reviewText.setAttribute('data-expanded', !isExpanded);
                        showMoreButton.textContent = isExpanded ? 'více' : 'méně';
                        emblaApi.reInit();
                    });
                }
            }

            slide.addEventListener('click', (event) => {
                if (isDragging) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            });
        });

        prevButton.addEventListener('click', () => emblaApi.scrollPrev());
        nextButton.addEventListener('click', () => emblaApi.scrollNext());

        emblaApi.on('select', () => {
            const canScrollPrev = emblaApi.canScrollPrev();
            const canScrollNext = emblaApi.canScrollNext();
            prevButton.disabled = !canScrollPrev;
            nextButton.disabled = !canScrollNext;
        });
    });
};
